import { ScopeButton } from '@monorepo/shared-lib';
import GuideStepOne from 'assets/images/entity-guide-step1.svg';
import GuideStepTwo from 'assets/images/entity-guide-step2.svg';
import GuideStepThree from 'assets/images/entity-guide-step3.svg';
import { StyledCard } from 'components/Custom/card';
import { CardListSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultIconClose } from 'shared/styles/common';
import { Preference, PreferenceActions } from 'utils/preferences';
import { ENTITY_TUTORIAL_HIDE } from '.';

interface EntityGuideProps {
  setShowCard: (show: boolean) => void;
  handlePreferences: (action: PreferenceActions, preference: Preference) => any;
}

const msgBoxWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minWidth: 300,
  maxWidth: 300,
  minHeight: 290,
};

export const EntityGuide: React.FC<EntityGuideProps> = ({
  setShowCard,
  handlePreferences,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setShowCard(false);
    handlePreferences(PreferenceActions.SET, {
      name: ENTITY_TUTORIAL_HIDE,
      value: true,
    });
  };

  return (
    <StyledCard
      width="100%"
      spreadcontent
      fullsize
      hideheader
      style={{
        marginBottom: '20px',
        width: '100%',
        position: 'relative',
      }}
      extra={
        <DefaultIconClose
          role="button"
          tabIndex={0}
          aria-label={t('common.close')}
          style={{
            top: '25',
            position: 'absolute',
            right: '25',
          }}
          onClick={handleClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleClose();
            }
          }}
        />
      }
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
          width: '100%',
          flexWrap: 'wrap',
          //gap: 50,
        }}
      >
        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('organisation.entities-guide.step1-title')}
            </CardTitleLargeSpan>

            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('organisation.entities-guide.step1-description')}
              </p>
            </CardListSpan>
          </div>
          <div style={{ marginBottom: 10 }}>
            <img alt="mappin-step-1" src={GuideStepOne} />
          </div>
        </div>
        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('organisation.entities-guide.step2-title')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('organisation.entities-guide.step2-description')}
              </p>
            </CardListSpan>
          </div>
          <div>
            <img alt="mapping-step-2" src={GuideStepTwo} />
          </div>
        </div>

        <div style={msgBoxWrapper}>
          <div>
            <CardTitleLargeSpan>
              {t('submissions.add-a-tax-return')}
            </CardTitleLargeSpan>
            <CardListSpan>
              <p style={{ paddingInlineStart: 3, maxWidth: 330, margin: 0 }}>
                {t('organisation.entities-guide.step3-description')}
              </p>
            </CardListSpan>
          </div>
          <div>
            <img alt="mapping-step-3" src={GuideStepThree} />
          </div>
        </div>
      </div>
      <ScopeButton
        type="default"
        onClick={handleClose}
        style={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          width: 'auto',
          height: 28,
          fontSize: '12px',
          padding: '0 12px',
        }}
      >
        {t('common.close')}
      </ScopeButton>
    </StyledCard>
  );
};
